import { ITreeNode } from "../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode";
import { CompleteView } from "../elements/nodeViews/CompleteView";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";
import { IViewFactory } from "./IViewFactory";

export class CompleteFactory extends IViewFactory {
    public override MakeView(node: ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>, mpan: string, _serviceLine: string): JSX.Element {
        return <CompleteView key={node.Identifier()} node={node} mpan={mpan} />;
    }
}
